import { render, staticRenderFns } from "./Save_comp.vue?vue&type=template&id=0bb8faba&scoped=true&"
import script from "./Save_comp.vue?vue&type=script&lang=js&"
export * from "./Save_comp.vue?vue&type=script&lang=js&"
import style0 from "./Save_comp.vue?vue&type=style&index=0&id=0bb8faba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb8faba",
  null
  
)

export default component.exports